// extracted by mini-css-extract-plugin
module.exports = {"header":"ProfileEditView_header__2LN26","archived":"ProfileEditView_archived__UtxfX"};